<form class="px-4 py-3 mt-20" [formGroup]="myForm" (ngSubmit)="updateProfile(myForm.value)">

    <div class="shadow-md p-3 rounded-md">
        <div class=" gap-y-2 gap-x-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            <span class="block mb-3 text-black text-sm col-span-full font-medium font-mont">Personal</span>

            <div class="flex mb-3 col-span-full">
                <input #fileInput accept="image/*" mat-button type="file" style="display:none"
                    (change)="displayPassport($event.target.files, myForm.value)">

                <span class="flex gap-2 items-center justify-center">
                    <img src={{image}} id="passport" onerror="this.src='assets/images/man.png'"
                        (click)="fileInput.click();" class="object-cover" />
                    <button type="button" style="color:black
                        " class="text-xs px-2 py-1 rounded-md bg-slate-200 text-black"
                        (click)="fileInput.click();">Change Passport</button>
                </span>
            </div>

            <app-custom-field label="Surname" name="lastName" [form]="myForm">
                <input type="text" class="custom-input" name="lastName" formControlName="lastName" required />
            </app-custom-field>

            <app-custom-field label="First Name" name="firstName" [form]="myForm">
                <input type="text" class="custom-input" name="firstName" formControlName="firstName" required />
            </app-custom-field>

            <app-custom-field label="Middle Name" name="middleName" [form]="myForm">
                <input type="text" class="custom-input" name="middleName" formControlName="middleName" />
            </app-custom-field>

            <app-custom-field label="Gender" name="gender" [form]="myForm">
                <mat-select name="gender" formControlName="gender">
                    <mat-option *ngFor="let gender of genders" [value]="gender.value">
                        {{ gender.value }}
                    </mat-option>
                </mat-select>
            </app-custom-field>

            <app-custom-field label="Marital Status" name="maritalStatus" [form]="myForm">
                <mat-select name="maritalStatus" formControlName="maritalStatus">
                    <mat-option *ngFor="let marital of maritals" [value]="marital.value">
                        {{ marital.value }}
                    </mat-option>
                </mat-select>
            </app-custom-field>

            <app-custom-field label="Date of Birth" name="dateOfBirth" [form]="myForm">
                <input type="date" inputmode="tel" class="custom-input" name="dateOfBirth" formControlName="dateOfBirth"
                    required />
            </app-custom-field>

            <app-custom-field label="Nationality" name="nationality" [form]="myForm">
                <mat-select name="nationality" formControlName="nationality" (selectionChange)="displayStates($event)">
                    <mat-option *ngFor="let c of countries" [value]="c.country">
                        {{ c.country }}
                    </mat-option>
                </mat-select>
            </app-custom-field>

            <app-custom-field label="State Of Origin" name="state" [form]="myForm">
                <mat-select name="state" formControlName="stateOfOrigin" id="stateOfOrigin">
                    <mat-option *ngFor="let s of disp" [value]="s">
                        {{ s }}
                    </mat-option>
                </mat-select>
            </app-custom-field>

            <span class="block my-3 text-black text-sm col-span-full font-medium font-mont">Contact</span>

            <app-custom-field label="Phone Number" name="phone1" [form]="myForm">
                <input type="text" inputmode="tel" class="custom-input" name="phone1" formControlName="phone1"
                    required />
            </app-custom-field>

            <app-custom-field label="Phone Number 2" name="phone2" [form]="myForm">
                <input type="text" inputmode="tel" class="custom-input" name="phone2" formControlName="phone2" />
            </app-custom-field>

            <app-custom-field class="md:col-span-2" label="Email" name="email" [form]="myForm">
                <input type="email" inputmode="email" class="custom-input" name="email" formControlName="email"
                    required />
            </app-custom-field>

            <app-custom-field [taller]="true" class="col-span-full" label="Address" name="address" [form]="myForm">
                <textarea type="text" class="custom-input py-2" rows="" name=" address"
                    formControlName="address"></textarea>
            </app-custom-field>

            <span class="block my-3 text-black text-sm col-span-full font-medium font-mont">Referee</span>

            <app-custom-field label="Full Name" name="k_name" [form]="myForm">
                <input type="text" class="custom-input" name="k_name" formControlName="k_name" />
            </app-custom-field>

            <app-custom-field label="Phone Number" name="k_phone" [form]="myForm">
                <input type="text" inputmode="tel" class="custom-input" name="k_phone" formControlName="k_phone" />
            </app-custom-field>

            <app-custom-field class="md:col-span-2" label="Email" name="k_email" [form]="myForm">
                <input type="email" inputmode="email" class="custom-input" name="k_email" formControlName="k_email" />
            </app-custom-field>
        </div>
    </div>

    <button type="submit" name="submit" class="floating-btn" color="primary" *ngIf="saveProfile">
        <mat-icon>save</mat-icon>
    </button>
    <button type="button" name="edit1" class="floating-btn" color="primary" (click)="editProfile()"
        *ngIf="!saveProfile">
        <mat-icon>create</mat-icon>
    </button>
</form>